<template>
  <div style="height: 100%">
    <div class="scrollbar-internal" ref="scrollbar">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import OverlayScrollbars from "overlayscrollbars";
import "overlayscrollbars/css/OverlayScrollbars.css";
export default {
  props: {
    horizontal: {
      default: "hidden",
    },
    autoHide: {
      default: "leave",
    },
  },
  mounted() {
    this.$nextTick(() => {
      OverlayScrollbars(this.$el, {
        overflowBehavior: { x: this.horizontal },
        autoUpdate: true,
        scrollbars: { autoHide: this.autoHide },
      });
    });
  },
};
</script>

<style lang="scss">
.os-theme-dark > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle {
  background: rgba(0, 0, 0, 0.2);
}

.os-theme-dark > .os-scrollbar:hover > .os-scrollbar-track > .os-scrollbar-handle {
  background: rgba(0, 0, 0, 0.3);
}

.os-theme-dark > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle.active {
  background: rgba(0, 0, 0, 0.35);
}
</style>
